import React from 'react';
import PropTypes from 'prop-types';

const WarningMessagePage = ({ message = 'Warning', subMessage = '' }) => (
    <div className="max-w-4xl mx-auto w-full px-2 py-4 mt-6 mb-6">
        <div
            className={
                'text-center px-4 sm:px-10 bg-yellow-100 w-5/6 mx-auto rounded'
            }
        >
            <div className="pt-10 pb-4 text-yellow-700 text-2xl font-semibold">
                {message}
            </div>
            <div className="pb-10 text-yellow-700">{subMessage}</div>
        </div>
    </div>
);

WarningMessagePage.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.object,
};

export default WarningMessagePage;
